import React, { useState, useEffect } from 'react';
import './src-components-MessageComponent-MessageComponent.styles.scss.js';
import MessageComponentBase from './src-components-MessageComponent-MessageComponentBase.js';

const MessageComponent = ({
  messageContent,
  id,
  messageType,
  footer,
  additionalComponents,
  showFeedback,
  isMessageRead = true,
  isLastMessage = false,
  urlMapping,
  customMessageType,
  attachments,
  formatType
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const handleTypingComplete = () => {
    if (Array.isArray(messageContent) && currentIndex < messageContent.length - 1) {
      setTimeout(() => {
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, 500);
    } else {
      setIsTypingComplete(true);
    }
  };
  useEffect(() => {
    setCurrentIndex(0);
    setIsTypingComplete(false);
  }, [messageContent]);
  if (Array.isArray(messageContent)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, messageContent.slice(0, currentIndex + 1).map((content, index) => /* @__PURE__ */ React.createElement(
      MessageComponentBase,
      {
        key: `${id}-${index}`,
        messageContent: content,
        id: `${id}__${index}`,
        messageType,
        footer: index === messageContent.length - 1 ? footer : void 0,
        additionalComponents: index === messageContent.length - 1 && isTypingComplete ? additionalComponents : void 0,
        showFeedback: showFeedback && index === messageContent.length - 1 && isTypingComplete && !additionalComponents && !customMessageType,
        isMessageRead,
        isLastMessage: isLastMessage && index === messageContent.length - 1,
        disableTypingEffect: index < currentIndex,
        onTypingComplete: index === currentIndex ? handleTypingComplete : void 0,
        urlMapping,
        attachments,
        formatType
      }
    )));
  }
  return /* @__PURE__ */ React.createElement(
    MessageComponentBase,
    {
      key: id,
      messageContent,
      id,
      messageType,
      footer,
      additionalComponents,
      showFeedback: showFeedback && isTypingComplete && !additionalComponents && !customMessageType,
      isMessageRead,
      isLastMessage,
      urlMapping,
      attachments,
      formatType
    }
  );
};

export { MessageComponent as default };
//# sourceMappingURL=src-components-MessageComponent-MessageComponent.js.map
